'use client';

import classNames from 'classnames';
import { useParams } from 'next/navigation';
import { overlay } from 'overlay-kit';
import { useEffect } from 'react';

import { useRealtorInfo } from '@/app/(realtor)/realtor/[realtorCd]/api';
import BottomSheet from '@/components/common/bottomSheets';
import AppDownload from '@/components/common/bottomSheets/etc/appDownload';
import CommonBackButton from '@/components/common/commonBackBtn';
import useMobileStore from '@/store/mobileStore';
import { handleSendGAEvent } from '@/utils/google';
import useControlTitle from '@/utils/hooks/useControlTitle';
import { appToHome, appToShare } from '@/utils/js/webView';

export default function RealtorDetailTop() {
  const { realtorCd } = useParams();
  const { hideTitle } = useControlTitle();
  const { data, isLoading } = useRealtorInfo(realtorCd as string);
  const { isMobile, isWebView } = useMobileStore();

  useEffect(() => {
    if (Boolean(isMobile && !isWebView) && !sessionStorage.getItem('isAppDownloadOpen')) {
      overlay.open(
        ({ isOpen, close }) => {
          return (
            <BottomSheet isOpen={isOpen} close={close} title="">
              <AppDownload close={close} />
            </BottomSheet>
          );
        },
        { overlayId: 'appDownload' },
      );
    }
  }, [isMobile, isWebView]);

  return (
    <header id="header" className="app_bar_top">
      {/* 헤더 일반 */}
      <div className="inner">
        {/* 좌측영역 */}
        {isWebView && (
          <div className="area_leading">
            <CommonBackButton />
          </div>
        )}

        {/* 중앙영역 */}
        <div className={classNames('headline', { isWebView })}>
          {!hideTitle && !isLoading && data && <p className="title">{data?.rname}</p>}
        </div>

        {/* 우측영역 */}
        {isWebView && (
          <div className="area_trailing">
            <button
              className="btn btn_home"
              onClick={() => {
                handleSendGAEvent('realtor_detail_home_btn', {
                  event_category: 'realtor',
                });
                appToHome();
              }}
            >
              <span className="text_blind">메인 바로가기</span>
            </button>
            <button
              className="btn btn_share"
              onClick={() => {
                handleSendGAEvent('realtor_detail_share_btn', {
                  event_category: 'realtor',
                });
                appToShare(window.location.href);
              }}
            >
              <span className="text_blind">공유</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
